
import React from 'react';
import DOMPurify from 'dompurify';

interface SimpleRichTextProps {
  content: string;
  className?: string;
}

export const SimpleRichText: React.FC<SimpleRichTextProps> = ({ 
  content,
  className = ''
}) => {
  // If content is empty, return null
  if (!content) {
    return null;
  }

  // Sanitize content to prevent XSS
  const sanitizedContent = DOMPurify.sanitize(content);
  
  return (
    <div 
      className={className} 
      dangerouslySetInnerHTML={{ __html: sanitizedContent }}
    />
  );
};
